import { render, staticRenderFns } from "./advancedVersion.vue?vue&type=template&id=3ee8f8a6&scoped=true"
import script from "./advancedVersion.vue?vue&type=script&lang=js"
export * from "./advancedVersion.vue?vue&type=script&lang=js"
import style0 from "./advancedVersion.vue?vue&type=style&index=0&id=3ee8f8a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee8f8a6",
  null
  
)

export default component.exports